//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ThemakiezerApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getEmbed(embedId: string): Promise<CollectionItem[]> {
        let url_ = this.baseUrl + "/api/v1/collection/themakiezer/{embedId}";
        if (embedId === undefined || embedId === null)
            throw new Error("The parameter 'embedId' must be defined.");
        url_ = url_.replace("{embedId}", encodeURIComponent("" + embedId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmbed(_response);
        });
    }

    protected processGetEmbed(response: Response): Promise<CollectionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollectionItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionItem[]>(null as any);
    }
}

export interface BaseCollectionModel {
    Id: string;
    CandidateIds: string[];
    OriginModule: string;
    OriginalId: string;
    PrefixedId?: string | undefined;
    MoreDataAvailable?: boolean;
    LastUpdate: Date;
}

export interface CollectionItem extends BaseCollectionModel {
    title: string;
    mainTitle?: string | undefined;
    subtitle?: string | undefined;
    series?: string[] | undefined;
    volume?: string | undefined;
    volumeTitle?: string | undefined;
    authors?: string[] | undefined;
    shortDescription?: string | undefined;
    simpleDescription?: string | undefined;
    longDescription?: string | undefined;
    descriptiveTerms?: string[] | undefined;
    genre?: string[] | undefined;
    medium?: Medium;
    isbns?: string[] | undefined;
    fictional?: boolean;
    imageUrls?: { [key: string]: string; } | undefined;
    originalUrl?: string | undefined;
}

export enum Medium {
    Book = "book",
    AudioBook = "audiobook",
    Comic = "comic",
    Magazine = "magazine",
    Video = "video",
    VideoGame = "videogame",
    Game = "game",
    Unknown = "unknown",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}